import RecordableView from '@/template/views/RecordableView.vue';
import PaymentPlanView from '@/template/components/paymentPlan/PaymentPlanView.vue';
var titleKey = function () { return 'PaymentPlan.Title'; };
var instructionLinksFactory = function (configuredLinks, languageCode, paymentPlan) {
    var type = null;
    return {
        id: "paymentPlan",
        type: type
    };
};
var paymentPlan = function (paymentPlan) {
    return { paymentPlan: paymentPlan };
};
export var route = {
    path: '/paymentPlan/:id',
    component: RecordableView,
    props: {
        titleKey: titleKey,
        recordableType: "PaymentPlan",
        instructionLinksFactory: instructionLinksFactory,
        multipleSections: false
    },
    children: [
        {
            name: 'paymentPlan',
            path: '',
            component: PaymentPlanView,
            meta: {
                title: 'PaymentPlan.Title',
                section: 1,
                props: paymentPlan,
                deletable: false
            }
        }
    ]
};
